export default __webpack_public_path__ + "static/media/photo--sm--55.bf6bca13.jpg";